// extracted by mini-css-extract-plugin
export default {"button":"_3kHy","arrow":"pCTW","text":"_38jJ"};